// extracted by mini-css-extract-plugin
export default {"textBox":"text-dnd_textBox__KZFaF","image":"text-dnd_image__oCgLz","dragging":"text-dnd_dragging__cc267","emptyBoxSpan":"text-dnd_emptyBoxSpan__kb88m"};